module.exports = __webpack_public_path__ + "img/new-object-delivery.b82fab65.png";